import '../sass/project.scss';

/* Project specific Javascript goes here. */

// FAQ accordion — landing page
document.addEventListener('DOMContentLoaded', () => {
  document.querySelectorAll('.landing-faq-question').forEach(btn => {
    btn.addEventListener('click', () => {
      const item = btn.closest('.landing-faq-item');
      const isOpen = item.classList.contains('open');
      document.querySelectorAll('.landing-faq-item').forEach(i => i.classList.remove('open'));
      if (!isOpen) item.classList.add('open');
    });
  });
});
